import api from '../axiosInstance';
import { MESSAGE_ENDPOINTS } from '../constants';

export const SendTestTextMsg = (customerId, deviceId, msgContent, fromMobile, toMobile) => {
  const data = {
    customer_id : customerId,
    device_id : deviceId,
    from_mobile : fromMobile,
    to_mobile : '91'+toMobile,
    msgType : "text",
    content : msgContent,
    delivery: "C"

  }
  return api.post(MESSAGE_ENDPOINTS.TEST, data);
}

export const SendBulkMSG = (data) => {
  return api.post(MESSAGE_ENDPOINTS.BULK_MESSAGE, data);
}